import { ClarityEvents } from '../../../../../lib/clarity/types/clarityEvents.types';
import { captureEvent } from '../../../../../lib/clarity/utils/captureEvent.utils';
import { Brand } from '../../../../context/ApplicationContext/applicationContext.types';
import useEnterBrand from '../../../../context/ApplicationContext/hooks/useEnterBrand/useEnterBrand';

export const useEnterBrandFromHome = () => {
  const { enterBrand } = useEnterBrand();

  const enterBrandFromHome = (brand: Brand) => {
    captureEvent(ClarityEvents.CLICKED_HOME_BRAND_SELECTOR);
    enterBrand(brand);
  };

  return { enterBrandFromHome };
};
